export default {
  Title: 'Καταστήματα | Κατάστημα | Καταστήματα',

  List: {
    Title: 'Δείτε τα καταστήματά μας'
  },

  SelectStoreDialog: {
    Title   : 'Καταστήματα',
    Subtitle: 'Επιλέξτε κατάστημα'
  },

  Status: {
    Opened        : 'Ανοιχτά',
    Closed        : 'Κλειστά',
    ClosedNoOrders: 'Το κατάστημα είναι κλειστό και δεν δέχεται παραγγελίες!',
    NoDelivery    : 'Το κατάστημα δεν δέχεται παραγγελίες διανομής!',
    NoCollection  : 'Το κατάστημα δεν δέχεται παραγγελίες παραλαβής!'
  },

  OrderTime: {
    Suffix  : '@:Store.OrderTime.SuffixSM',
    SuffixXL: '@:Store.OrderTime.SuffixLG',
    SuffixLG: 'λεπτά',
    SuffixMD: '@:Store.OrderTime.SuffixSM',
    SuffixSM: 'λεπτά',
    SuffixXS: '\''
  }
}
